import { Injectable } from '@angular/core'

import { PkwDatastore } from '../../pkw-data/pkw-datastore'
import { TipoDeConfiguracao } from '../../pkw-data/core/configuracao/tipo-de-configuracao.model'
import { TipoDeConfiguracaoId } from '../../pkw-data/core/configuracao/tipo-de-configuracao-id.enum'
import { Configuracao } from '../../pkw-data/core/configuracao/configuracao.model'
import { ValorIntegracaoConciliadorWCONT } from './configuracao-integracao-operadora'

@Injectable()
export class ConfiguracaoService {
    constructor(private pkwDatastore: PkwDatastore) {}

    obterTipo(id: TipoDeConfiguracaoId) {
        return this.pkwDatastore.findRecord(TipoDeConfiguracao, id)
    }

    obterTipos() {
        return this.pkwDatastore
            .findAll(TipoDeConfiguracao, { 'page[limit]': 1000 })
            .map(response => {
                return response.getModels()
            })
    }

    obter(idTipo: TipoDeConfiguracaoId) {
        return this.pkwDatastore
            .findAll(Configuracao, {
                'filter[chave][id]': idTipo,
                include: 'chave'
            })
            .map(response => {
                return response.getModels()[0]
            })
    }

    nova(idTipo: TipoDeConfiguracaoId) {
        return Promise.resolve(this.obterTipoEmMemoria(idTipo))
            .then(tipoEmMemoria => {
                if (tipoEmMemoria) {
                    return tipoEmMemoria
                }

                return this.obterTipo(idTipo).toPromise()
            })
            .then(tipo => {
                const configuracao = this.pkwDatastore.createRecord(Configuracao)

                configuracao.chave = tipo
                configuracao.setValor(this.valorDefault(idTipo))

                return configuracao
            })
    }

    private valorDefault(idTipo: TipoDeConfiguracaoId) {
        switch (idTipo) {
            case TipoDeConfiguracaoId.IntegracaoCollectPorBandeira:
            case TipoDeConfiguracaoId.IntegracaoConciliadorWcont:
                return <ValorIntegracaoConciliadorWCONT>{ CodigosContabeis: [] }
        }
    }

    private obterTipoEmMemoria(idTipo: TipoDeConfiguracaoId) {
        return this.pkwDatastore.peekRecord(TipoDeConfiguracao, idTipo)
    }
}



// WEBPACK FOOTER //
// ./src/app/configuracao/shared/configuracao.service.ts